<template>
  <main>
    <form class="info" ref="form" :model="form">
      <ul>
        <li prop="carNo">
          <h3>车牌号</h3>
          <input type="text" v-model="form.carNo" />
        </li>
        <li prop="carCategory">
          <h3>车牌类型</h3>
          <van-dropdown-menu :overlay="false">
            <van-dropdown-item v-model="form.carCategory" :options="option1" />
          </van-dropdown-menu>
        </li>
        <li prop="carType">
          <h3>车辆类型</h3>
          <van-dropdown-menu :overlay="false">
            <van-dropdown-item v-model="form.carType" :options="option2" />
          </van-dropdown-menu>
        </li>
      </ul>
    </form>
    <button id="btn" type="" class="btn btn-green" @click="submit()" >保存</button>
  </main>
</template>

<script>
import { Toast } from "vant";
import API from "../api/index";
import { Cookies } from "../util/index";

export default {
  name: "addcar",
  data() {
    return {
      form: {},
      option1: [
        { text: "蓝牌", value: "0" },
        { text: "新能源", value: "1" },
        { text: "黄牌", value: "2" },
      ],
      option2: [
        { text: "小型汽车", value: "小型汽车" },
        { text: "大型汽车", value: "大型汽车" },
        { text: "货车", value: "货车" },
      ],
    };
  },

  methods: {
    
    link(url) {
      this.$router.push(url);
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    submit() {
      console.log(Cookies.get("phoneNum"),);
      console.log(this.form.carCategory);
      if (!this.form.carNo) {
        Toast("请输入车牌号");
        return;
      }
      if (!this.form.carCategory) {
        Toast("请选择车牌类型");
        return;
      }
      if (!this.form.carType) {
        Toast("请选择车辆类型");
        return;
      }
      
      var _this = this;
      this.form.phoneNum = Cookies.get("phoneNum"),
      this.$http({
        method: "post",
        data: this.form,
        url: API.addCar_url,
      })
        .then(function (resp) {
          Toast.success("保存成功");
          document.getElementById("btn").disabled=true; 
          setTimeout(function () {
            // _this.$router.push({ path: "/mycar" });
            history.back();
          }, 3000);
        })
        .catch((resp) => {
          Toast.fail("保存失败");
        });
    },
  },
};
</script>

<style scoped>
/deep/.van-cell {
  margin: 50px 0;
  line-height: 60px;
}

/deep/.van-button {
  margin-top: 100px;
  height: 80px;
}

/deep/.info .van-popup--top {
  left: 50%;
  width: 47%;
  top: 15px;
}

/deep/.info .van-dropdown-menu {
  width: 300px;
}

/deep/.info .van-ellipsis {
  overflow: visible;
}

.info {
  margin: 20px;
}

.info ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 20px;
  font-size: 22px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 10px #ccc;
}

.info ul li + li {
  margin-top: 20px;
}

.info ul li h3 {
  color: #333;
}

.info ul li input {
  color: #666;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/addcar.vue